import SEO from "../components/common/SEO"
import PageBanner from "../components/layout/PageBanner"

import ContactInfo from "../components/contact/ContactInfo"
import ContactForm from "../components/contact/ContactForm"

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact"
        description="Contactez notre équipe pour toute demande concernant nos produits textiles, mercerie et accessoires."
        keywords="contact grossiste textile, mercerie Tunisie, fournitures textiles"
        url="https://www.khenissitextiles.com/contact"
      />

      <PageBanner
        title="Contact"
        subtitle="Notre équipe est à votre disposition pour répondre à toutes vos demandes."
      />

      {/* Contact */}
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">

          <div className="grid lg:grid-cols-2 gap-10">
            <ContactInfo />
        {/*   <ContactForm /> */}
          </div>

        </div>
      </section>

      {/* Google Maps */}
      <section className="pb-16 lg:pb-24">
        <div className="container mx-auto px-4 lg:px-8">

          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900">
              Notre localisation
            </h2>

            <p className="mt-3 text-gray-600">
              Retrouvez facilement notre magasin et nos bureaux.
            </p>
          </div>

          <div className="overflow-hidden rounded-2xl border border-gray-200 shadow-lg">

            <iframe
              title="Localisation Khenissi Textile"
              src="https://maps.google.com/maps?q=36.800907,10.177248&z=15&output=embed"
              width="100%"
              height="500"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />

          </div>
<div className="mt-6 text-center">
  <a
    href="https://www.google.com/maps/dir/?api=1&destination=36.800907,10.177248"
    target="_blank"
    rel="noopener noreferrer"
    className="
      inline-flex items-center
      px-6 py-3
      bg-gray-900
      text-white
      rounded-xl
      hover:bg-black
      transition
    "
  >
    Ouvrir dans Google Maps
  </a>
</div>
        </div>
      </section>
    </>
  )
}